/*
 * @Author: jinxiong
 * @Date: 2022-10-26 16:38:36
 * @LastEditTime: 2022-11-02 10:19:43
 * @Description: Do not edit
 */
import Vue from 'vue';
import {
  Select,
  Option,
  Pagination,
  Dialog,
  Menu,
  Submenu,
  Loading,
  MessageBox,
  Message,
  Notification,
  Alert,
} from 'element-ui';

Vue.use(Pagination);
Vue.use(Select);
Vue.use(Option);
Vue.use(Dialog);
Vue.use(Menu);
Vue.use(Submenu);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;
